// removed by extract-text-webpack-plugin
module.exports = {"location":"location__location___1RbFX"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Location/location.scss
// module id = 126
// module chunks = 0